import { Component } from '@angular/core';

/**
 * Generated class for the TravelIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'travel-icon',
  templateUrl: 'travel-icon.html'
})
export class TravelIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/travel-icon/travel-icon.ts